/**
 * ****************************************************************************
 * @description     :   Route for mobile module
 * @created at      :   2023/10/12
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import component of view
 */
const cm0011i = () => import('@/views/cm/cm0011i');
const authentication = () => import('@/views/cm/cm0011i/authentication');
const authenticationBackupcode = () =>
    import('@/views/cm/cm0011i/authentication/authenticationBackupcode');
const gs0510v = () => import('@/views/gs/gs0510v');
const gm0030v = () => import('@/views/gm/gm0030v');
const gs0193v = () => import('@/views/gs/gs0193v');
const gm0090v = () => import('@/views/gm/gm0090v');
const gm0060v = () => import('@/views/gm/gm0060v');
const gs0720v = () => import('@/views/gs/gs0720v');
const gm0070i = () => import('@/views/gm/gm0070i');
const gm0080v = () => import('@/views/gm/gm0080v');
const gm0040i = () => import('@/views/gm/gm0040i');

/**
 * Defined Router
 */
const resource = 'gm';
export default [
    {
        path: `/${resource}/gm0010i`,
        name: 'Gm0010i',
        component: cm0011i,
        meta: {
            title: 'ログイン',
            layout: 'EmptyLayout',
            isMobile: true,
            notCheckPublic: true,
            pcScreen: '/private/login'
        }
    },
    {
        path: `/${resource}/authentication_mobile`,
        name: 'authentication_mobile',
        component: authentication,
        meta: {
            title: '2要素認証',
            layout: 'EmptyLayout',
            isMobile: true,
            notCheckPublic: true,
            pcScreen: '/authentication'
        }
    },
    {
        path: `/${resource}/backupcode_mobile`,
        name: 'backupcode_mobile',
        component: authenticationBackupcode,
        meta: {
            title: '2要素認証(バックアップコード使用)',
            layout: 'EmptyLayout',
            isMobile: true,
            notCheckPublic: true,
            pcScreen: '/authentication/authenticationBackupcode'
        }
    },
    {
        path: `/${resource}/gm0020i`,
        name: 'Gm0020i',
        component: gs0510v,
        meta: {
            title: 'タイムレコーダー',
            isMobile: true,
            pcScreen: '/gs/gs0510v'
        }
    },
    {
        path: `/${resource}/gm0030v`,
        name: 'Gm0030v',
        component: gm0030v,
        meta: {
            title: '勤怠実績',
            isMobile: true,
            pcScreen: '/gs/gs0360v'
        }
    },
    {
        path: `/${resource}/gm0050v`,
        name: 'Gm0050v',
        component: gs0193v,
        meta: {
            title: '年次有給休暇の状況',
            isMobile: true,
            pcScreen: '/gs/gs0193v'
        }
    },
    {
        path: `/${resource}/gm0090v`,
        name: 'Gm0090v',
        component: gm0090v,
        meta: {
            title: '勤怠モニター',
            isMobile: true,
            pcScreen: '/gs/gs0060v'
        }
    },
    {
        path: `/${resource}/gm0060v`,
        name: 'Gm0060v',
        component: gm0060v,
        meta: {
            title: 'アラート(本人)',
            isMobile: true,
            pcScreen: '/gs/gs0710i'
        }
    },
    {
        path: `/${resource}/gm0061v`,
        name: 'Gm0061v',
        component: gs0720v,
        meta: {
            title: 'アラート詳細',
            isMobile: true,
            pcScreen: '/gs/gs0720v'
        }
    },
    {
        path: `/${resource}/gm0070i`,
        name: 'Gm0070i',
        component: gm0070i,
        meta: {
            title: '承認待ち一覧',
            isMobile: true,
            pcScreen: '/gs/gs0050v'
        }
    },
    {
        path: `/${resource}/gm0080v`,
        name: 'Gm0080v',
        component: gm0080v,
        meta: {
            title: 'アラート一覧',
            isMobile: true,
            pcScreen: '/gs/gs0711v'
        }
    },
    {
        path: `/${resource}/gm0040i`,
        name: 'Gm0040i',
        component: gm0040i,
        meta: {
            title: '申請一覧・各種申請',
            isMobile: true,
            pcScreen: '/gs/gs0520i'
        }
    }
];
